import { jsx } from "react/jsx-runtime";
import clsx from "clsx";
import { forwardRef } from "react";
const style_css_ts_vanilla = "";
var divider = "_4twsms0";
var thinner = "_4twsms1";
var verticalDivider = "_4twsms2";
var verticalThinner = "_4twsms3";
const defaultProps = {
  orientation: "horizontal",
  size: "default"
};
const Divider = forwardRef(
  (props, ref) => {
    const {
      orientation,
      className,
      size,
      dividerColor,
      style,
      ...otherProps
    } = {
      ...defaultProps,
      ...props
    };
    return /* @__PURE__ */ jsx(
      "div",
      {
        ref,
        className: clsx(
          divider,
          {
            [verticalDivider]: orientation === "vertical",
            [thinner]: size === "thinner" && orientation === "horizontal",
            [verticalThinner]: size === "thinner" && orientation === "vertical"
          },
          className
        ),
        style: { backgroundColor: dividerColor ? dividerColor : void 0, ...style },
        ...otherProps
      }
    );
  }
);
Divider.displayName = "Divider";
export {
  Divider
};
